import { createRootRouteWithContext, createRouter, Navigate, Outlet } from "@tanstack/react-router";
import type { CodeRouteToPath } from "@tanstack/router-core";
import type { QueryClient } from "@tanstack/react-query";

import { getContext } from "ui/Query";

import contents from "areas/content/routes";
import home from "areas/home/routes";
import partners from "areas/partners/routes";
import users from "areas/users/routes";
import validation from "core/validation";
import ErrorBoundary from "ui/ErrorBoundary";

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}

export type RouterContext = {
	queryClient: QueryClient;
};

export type ValidRoutes = CodeRouteToPath<typeof router>;

export const root = createRootRouteWithContext()({
	component: () => <Outlet />
});

export const tree = root.addChildren([contents, home, partners, users]);

const router = createRouter({
	routeTree: tree,
	context: {
		...getContext()
	},
	defaultPreload: "intent",
	scrollRestoration: false,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: (error) => <ErrorBoundary error={error} />,
	defaultOnCatch: (e) => {
		const error = validation.serializeError(e);
		/* if (!error.type) api.error.log({ name: error.name, message: error.message, stack: stack.componentStack }); */
		return error;
	},
	defaultNotFoundComponent: () => <Navigate to="/" />
});

export default router;